export enum LOCAL_STORAGE_KEYS {
  USER_TOKEN = "USER_TOKEN",
  AUTH_STORAGE = "auth-storage",
}
